const TEST_ID = {
  CONTAINER: 'contact-lfa-requests-block',
} as const;

export default TEST_ID;
